import { Environments } from '@/config';
import { LCMC_PRODUCTION } from './lcmc.production';
import { LCMC_STAGING } from './lcmc.staging';

export const LCMC = import.meta.env.MODE === Environments.PROD ? LCMC_PRODUCTION : LCMC_STAGING;
